// Vuetify 2's `v-date-picker range` returns the two dates in CLICK order, not chronological
// order, so every screen that reads `date[0]` / `date[1]` can produce from_date > to_date. Both
// backends put the pair straight into `DATE(...) BETWEEN ? AND ?`, which matches nothing when it
// is reversed — the screen then shows "0 records" for a range the operator knows is populated.
//
// Normalising in the store actions rather than in each view is deliberate: the view is the
// producer that gets it wrong, and `grep -rn from_date src/` finds five of them: SMS Logs search,
// the Bookings picker, the post-import refresh, Reports (the polling search AND the export that
// generates the file) and the Dashboard. Applying it in the actions covers every caller of those
// actions, present and future; a screen that called `@/apis` directly would still have to do this
// itself.
//
// ISO `YYYY-MM-DD` strings compare correctly with `>`, which is what the pickers emit. A range
// with only one end is left exactly as it is — this never invents a bound the caller did not ask
// for. Whether one end is USABLE is the endpoint's business and it differs: `/bookings` and
// `/sms_logs` ignore an incomplete pair, `/reports*` reject it with `Missing parameter: to_date`.
// Screens that talk to the latter must not send one (see Dashboard.vue / Reports.vue).
//
// An end that is PRESENT but empty is a different thing, and a damaging one: `new URLSearchParams`
// serialises `undefined` as the four-character string "undefined", which the backend then applies
// as a real `BETWEEN` bound and matches nothing. Those keys are removed rather than forwarded.
export function sortDateRangeParams(params) {
  if (!params) return params
  const present = value => value !== undefined && value !== null && value !== ''

  if (present(params.from_date) && present(params.to_date)) {
    return String(params.from_date) > String(params.to_date) ? { ...params, from_date: params.to_date, to_date: params.from_date } : params
  }

  const empty_ends = ['from_date', 'to_date'].filter(key => key in params && !present(params[key]))
  if (!empty_ends.length) return params
  const stripped = { ...params }
  for (const key of empty_ends) delete stripped[key]
  return stripped
}
